export var getCanvasGradient = function getCanvasGradient(params) {
  var chartHeight = params.chartHeight,
    ctx = params.ctx,
    stopColors = params.stopColors;
  var gradient = ctx.createLinearGradient(0, 0, 0, chartHeight);
  stopColors.forEach(function (_ref) {
    var offset = _ref.offset,
      color = _ref.color;
    return gradient.addColorStop(offset, color);
  });
  return gradient;
};